<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.cons{
  display: none;
}
.effect-lists li{
  margin-right: 30px;
  float: left;
  width: 18%;
  text-align: center;
  margin-bottom: 30px;
}
.effect-lists li:nth-last-of-type(1),.effect-lists li:nth-last-of-type(2),.effect-lists li:nth-last-of-type(3),.effect-lists li:nth-last-of-type(4),.effect-lists li:nth-last-of-type(5){
  margin-bottom: 0;
}
.effect-lists li:nth-child(5n){
  margin-right: 0;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner3.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>SSR/STR检测</h1>-->
<!--          <h2 class="mt10">SSR / STR detection（多态分析、性状定位、品种鉴定）</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">微卫星标记（Microsatellite）也称为短串联重复序列（STR）或简单重复序列（SSR），是广泛分布在真核生物基因组中的简单重复序列。微卫星位点通常通过PCR扩增和电泳检测，并根据片段大小分离等位基因进行分析；扩增后的等位微卫星利用ABI3730遗传分析仪对荧光标记的DNA片段进行检测，结合分子量内标进行DNA片段长度计算，使SSR/STR分型变得高效快捷、精确。</p>
      <!-- <div class="c-title">实验原理<small>Experimental Principle</small></div> -->
      <!-- <div class="tc"><img src="@/assets/images/ssr_1.png"> </div> -->
      <div class="c-title">实验流程<small>Experimental Procedures</small></div>
      <div class="tc"><img src="@/assets/images/ssr_2.png"> </div>
      <div class="c-title">SSR引物开发<small>SSR Primer Development</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/snp_6.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p>通过基因组测序或转录组测序后分析的ssr位点进行位点和引物筛选，先初步选取较好的多态性位点和适合PCR扩增引物200 ～ 400对，对引物进行PCR扩增实验筛选，再根据ABI3730xl毛细管电泳检测位点的多态性（比传统的聚丙烯电泳法快捷、准确），对于有多态性的位点，进行DNA测序验证，最终根据多态性的需求选取15 ～ 30对引物用于大样本的多态性检测、研究；样本批量扩增用带有荧光标记（FAM／HEX／TMR／ROX等）的引物，对批量样本进行PCR扩增。我公司拥有多台PCR仪和ABI3730遗传分析仪，可以满足大量样本扩增、检测需求。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">测序仪检测<small>Sequencer Detection</small></div>
      <p class="tc">带有荧光标记的PCR产物进行稀释后与分子量内标混合，用3730xl等测序仪进行毛细管电泳，并得到原始数据。 </p>
      <div class="tc mt30"><img src="@/assets/images/ssr_4.png"> </div>
      <p class="img-info">应用3730xl毛细管电泳检测得到的原始图谱</p>
      <div class="c-title">原始数据分析<small>Raw Data Analysis</small></div>
      <p class="tc">编制panel和bin等文件，使用正版GeneMapper v4.0软件分析测序仪得到fsa文件，生成PDF图谱和Excel文档（包括size、基因分型等信息）</p>
      <div class="tc mt30"><img src="@/assets/images/ssr_5.png"> </div>
      <p class="img-info">GeneMapper软件分析后的电泳图谱</p>
      <div class="c-title">群体遗传学分析<small>Population Genetic Analysis</small></div>
      <p class="tc">利用生物信息学软件（POPGENE、MEGA、PHYLIP、ARLEQUIN等）对上述数据进行进一步分析，绘制遗传连锁图谱、分析连锁不平衡和分析多态性等。</p>
      <div class="tc mt30"><img src="@/assets/images/ssr_6.png"> </div>
      <div class="c-title">送样要求<small>Sample Delivery Requirements</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12" style="z-index: 2;">
          <div class="required left">
            <p class="mb20">1、叶片（未腐质）：2 ～ 3片，血液（ ≥ 1 mL）、基因组
            DNA（ ≥ 30 μL，浓度 ≥ 30 ng/μL）、纯度 OD 260/280
            在1.7 ～ 1.9 之间；</p>
            <p class="mb20">2、引物信息、片段长度范围、各位点重复单元信息。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img src="@/assets/images/rdna_2.png" class="img-fluid">
        </el-col>
      </el-row>
      <div class="c-title">结果交付<small>Provide Results</small></div>
      <p class="tc">引物、微卫星分析的原始数据以及GeneMapper生成的PDF图谱、包含片段长度等信息的Excel文档和进一步的分析结果等。</p>
      <div class="tc mt30"><img src="@/assets/images/ssr_8.png"> </div>
      <div class="tc mt30"><img src="@/assets/images/ssr_9.png"> </div>
      <div class="c-title">相关服务<small>Related services</small></div>
<!--      <ul class="services">-->
<!--        <li><img src="@/assets/images/ssr_service_1.png">引物合成</li>-->
<!--        <li><img src="@/assets/images/ssr_service_2.png">T5酶</li>-->
<!--        <li><img src="@/assets/images/ssr_service_3.png">DNA条码</li>-->
<!--      </ul>-->
      <ul class="effect-lists con">
        <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
          <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
          <p style="margin-top: 10px;">{{item.name}}</p>
        </li>
      </ul>
      <div class="cons">
        <ul class="effect-lists " style="display: flex!important;margin-top: 20px;">
          <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>

    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {
      currentType:-1,
      types: [
        {name: 'SNP检测', img: '5', ref: '/tec/SNP'},
        {name: '特定基因检测', img: '6', ref: '/tec/specific'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
      ],
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/SSR.vue